export default function viewModeMobileHandler() {
  var mobileFlag = true;
  if ($("html").hasClass("ismobile") || window.innerWidth < 767) {
    if (mobileFlag == true) {
      window.mobileFlag = false;

      $('.tab-panel').each(function () {
        $('.tab-content .product-list-container').removeClass('list-view table-view');
        $('.tab-content .product-list-container').addClass('grid-view');
      });
    }
  } else {
    if (mobileFlag == false) {
      mobileFlag = true;
    }
    $('.tab-content .product-list-container').removeClass('grid-view');
    var activeView = $(".view-mode .view-mode-active>span").data("attr");
    $('.tab-content .product-list-container').addClass(activeView);
  }
}